import * as tamu from './tamu-theme';
import * as csrrs from './csrrs-theme';

export const themes = {
  tamu,
  csrrs
};
